import { types } from "./types";

/**
 *
 * @name removePrecedingAndTraillingSpaces
 * @desc Sanitizes a string removing preceding and trailing empty space of a string
 * @param {string} input - field to be sanitized
 * @returns {string}
 * @memberof utils
 */
export const removePrecedingAndTraillingSpaces = (input) => {
  const inputType = types(input);

  if (!inputType.isDefined || inputType.isNull) {
    console.warn(
      "Warning: Input is null or undefined. The function expects a non-null, non-undefined string."
    );
    return input;
  }

  if (inputType.isString) {
    return input.trim().replace(/^\s+|\s+$/g, "");
  } else {
    console.warn(
      "Warning: Input is not a string. The function expects a string."
    );
    return input;
  }
};
